/**
 * Court layer: San Bernardino County Superior Court. See src/courts/index.js for the shape.
 * data/ has no San Bernardino material of its own; the statewide fee schedule's appendix
 * gives its first paper fees, which include a local courthouse construction surcharge.
 */
export default {
  id: "san-bernardino-superior",
  details: {
    fees: {
      firstPaper: {
        value: { unlimited: 435, limitedOver10k: 380, limitedUpTo10k: 240, udLimitedOver10k: 395, udLimitedUpTo10k: 255 },
        text: "San Bernardino adds a $35 courthouse construction surcharge to every first paper, so its limited civil first paper fees are higher than the statewide amounts.",
        cite: "Statewide Civil Fee Schedule, Appendix; GC 70624",
      },
    },
  },
};
